import paths from 'constants/paths';
import { SummaryPath } from 'new/form/model';

export const hausbankSummaryPath: SummaryPath = {
  create: paths.summaryPage,
  editOperation: paths.operation.inquiryDetails.edit.summaryPage,
  editCustomer: paths.customer.inquiryDetails.edit.summaryPage,
};
